<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      Akhir Studi Mahasiswa:
      <Link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('mahasiswa.edit.self')">
        {{ mahasiswa.name }}
      </Link>
    </h1>
    <div class="overflow-x-scroll bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4 text-left">
              Tanggal Input Akhir Studi
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              NIM
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Tahun Masuk
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Pendidikan
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Lembar Pengesahan
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Ijazah
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Transkrip Nilai
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Status
            </th>
            <th class="px-6 pt-6 pb-4 text-center">
              Aksi
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in eosRecords.data"
            :key="row.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="py-4 px-6 text-left border-t">
              {{ row.trn_date }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.nim }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.college_entry_year }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.jenjang_pendidikan }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              <div
                class="mb-2 text-sm font-medium"
                :class="verifiedCss(row.validation_doc_verified)">
                {{ row.validation_doc_verified ? `VERIF` : "BLM-VERIF" }}
              </div>
              <div>
                <p class="my-1 text-sm">
                  - Keterangan: {{ row.validation_doc_verified_notes }}
                </p>
              </div>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <div
                class="mb-2 text-sm font-medium"
                :class="verifiedCss(row.diploma_verified)">
                {{ row.diploma_verified ? `VERIF` : "BLM-VERIF" }}
              </div>
              <div>
                <p class="my-1 text-sm">
                  - Keterangan: {{ row.diploma_verified_notes }}
                </p>
              </div>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <div
                class="mb-2 text-sm font-medium"
                :class="verifiedCss(row.academic_transcript_verified)">
                {{ row.academic_transcript_verified ? `VERIF` : "BLM-VERIF" }}
              </div>
              <div>
                <p class="my-1 text-sm">
                  - Keterangan: {{ row.academic_transcript_verified_notes }}
                </p>
              </div>
            </td>
            <td class="py-4 px-6 text-left border-t">
              <span :class="getStatusClass(row.appstatus)" class="font-bold">{{
                row.appstatus
              }}</span>
            </td>
            <td class="py-4 px-4 text-center border-t">
              <Link class="btn-indigo" :href="route('eos.edit', row.id)">
                {{ getButtonActionText(row) }}
              </Link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="eosRecords.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import { Link } from '@inertiajs/vue2'

export default {
  metaInfo () {
    return {
      title: 'List Akhir Studi',
    }
  },

  layout: Layout,

  props: {
    currGraduationYear: Number,
    mahasiswa: Object,
    eosRecords: Object,
    isInputEosClosed: Boolean,
  },

  components: {
    Pagination,
    Link,
  },

  methods: {
    getButtonActionText (eos) {
      return eos.approval_status_payment_id === 4 ||
        eos.approval_status_payment_id === 5 ||
        this.isInputEosClosed
        ? 'LIHAT'
        : 'PROSES'
    },
    verifiedCss (stat) {
      return stat ? 'text-green-600' : 'text-red-600'
    },
    getStatusClass (stat) {
      return stat === 'Layak Bayar'
        ? 'text-green-600'
        : stat === 'Tidak Layak Bayar'
        ? 'text-red-600'
        : ''
    },
  },
}
</script>
